import React, { useEffect, useRef, useState } from "react";
import { ValidatorForm } from "react-form-validator-core";
import { getDate, selectValueGetterr } from "../../../../utils/helper";
import Switch from "react-switch";
import TextValidator from "../../../partial/TextValidator";
import TextAreaValidator from "../../../partial/TextAreaValidator";
import { connect } from "react-redux";
import { decrypt } from "../../../../utils/encodingdecoding";
import { clearBusinessGoal, getBusinessGoal } from "../../../../actions/businessGoal";
import SelectValidator from "../../../partial/SelectValidator";
import { selectValueGetter } from "../../../../utils/helper";
import CKEditor from "ckeditor4-react";
import { useLocation } from "react-router-dom";

const CampaignDetailsTab = ({ getBusinessGoal, clearBusinessGoal, BusinessGoal, onChange, formateData, SetFormateData, error, handleTabChange, handleImgUpload }) => {
    // const [toggle, setToggle] = useState(true);
    // const { data, onHandleChange } = props;
    const [options, setOptions] = useState();
    const [datas, setDatas] = useState();
    const [loader, setLoader] = useState(false);
    const [imgSize, setImgSize] = useState(false);

    const imageInputRef = useRef();
    const location = useLocation()
    // const { onChange, formateData, error, handleTabChange } = props;

    const { name, endDateTime, startDateTime, description, status, businessGoal, taglastcheck, processingMode, tags, offerDetail } = formateData;
    const [activeMode, setActiveMode] = useState("editor");
    const onSubmit = () => { };

    const [newTag, setNewTag] = useState("");
    const [tagList, setTagList] = useState([]);
    const [selectedTag, setSelectedTag] = useState("");

    useEffect(() => {
        const desc = description?.trim() || "";

        if (!desc || desc.startsWith("<")) {
            setActiveMode("editor");
        } else {
            setActiveMode("custom");
        }
    }, [description]);

    useEffect(() => {
        if (!Array.isArray(tags)) return;

        const formattedTags = tags.flatMap((tag) => {

            if (tag?.TagKey) {
                return (
                    tag?.values?.map((item) => item.Name) ||
                    tag?.Values?.map((item) => item.Name) ||
                    []
                );
            }

            if (typeof tag === "string") {
                return [tag.split(":")[0]];
            }

            return [];
        });

        setTagList(formattedTags);
    }, [tags, location.pathname]);

    const handleNext = () => {
        handleTabChange({ key: "Rules" });
    };

    const handleFile = (e) => {
        if (e.target.files[0] && e.target.files[0]?.size > 1 * 1024 * 1024) {
            setImgSize(true);
        } else {
            const filedata = e.target.files[0];
            setImgSize(false);
            handleImgUpload(filedata)
        }
    };

    // useEffect(() => {
    //     if (Array.isArray(taglastcheck)) {
    //         const tagKeys = taglastcheck?.map((item) => {
    //             if (typeof item === 'string' && item.includes(':')) {
    //                 return item.split(':')[0];
    //             } else {
    //                 return item.TagKey;
    //             }
    //         }).join(', ');
    //         setDatas(tagKeys);
    //     } else {
    //         console.error('formData.taglastcheck is not an array:', taglastcheck);
    //     }
    // }, [taglastcheck]);

    const [templateOptions] = useState([
        {
            value: "",
            label: "Select",
        },

        {
            value: "Promotion",
            label: "Promotion",
        },
        {
            value: "GoogleRating",
            label: "GoogleRating",
        },
        {
            value: "SocialMedia",
            label: "SocialMedia",
        },

    ]);
    const [Options] = useState([
        {
            value: 0,
            label: "Transaction",
            type: 0
        },
        {
            value: 1,
            label: "Triggered",
            type: 1
        },
        {
            type: 2,
            value: "TimeBased",
            label: "TimeBased",
        },

    ]);

    const [state, setState] = useState({
        data: [],
        goals: [],
    });

    const { goals, data } = state;

    useEffect(() => {
        fetchBusinessGoals();
    }, []); // eslint-disable-line

    useEffect(() => {
        setState({ ...state, data: BusinessGoal });
    }, [BusinessGoal]);

    useEffect(() => {
        const industry = decrypt(localStorage.getItem("industry"));
        data?.map((item) => {
            if (item.industry === industry) {
                setState({ ...state, goals: item.goals });
            }
        });
    }, [data]); // eslint-disable-line

    async function fetchBusinessGoals() {
        setLoader(true)
        const token = JSON.parse(localStorage.getItem("token_gen"));
        await clearBusinessGoal();
        await getBusinessGoal(token?.access_token);
        setLoader(false)
    }

    useEffect(() => {
        const temp = [];
        goals?.map((goal) => {
            return temp.push({
                value: goal?.businessgoal,
                label: goal?.businessgoal,
            });
        });
        setOptions(temp);
    }, [goals]);

    const handleAddTag = () => {
        const tagName = newTag.trim();

        if (!tagName) return;

        const exists = tagList.some(
            (tag) => tag.toLowerCase() === tagName.toLowerCase()
        );

        if (exists) return;

        const updatedTags = [...tagList, tagName];

        setTagList(updatedTags);

        onChange({
            target: {
                name: "tags",
                value: updatedTags.map(
                    (tag) => `${tag}:${tag}:#d81313`
                ),
            },
        });

        setNewTag("");
    };

    const handleDeleteTag = () => {
        if (!selectedTag) return;

        const updatedTags = tagList.filter(
            (tag) => tag !== selectedTag
        );

        setTagList(updatedTags);

        const isCreateMode = location.pathname.includes("create-campaign");

        onChange({
            target: {
                name: "tags",
                value: isCreateMode
                    ? updatedTags.map((tag) => ({
                        TagKey: tag,
                        Values: [
                            {
                                Name: tag,
                                Color: "#d81313",
                            },
                        ],
                    }))
                    : updatedTags.map(
                        (tag) => `${tag}:${tag}:#d81313`
                    ),
            },
        });

        setSelectedTag("");
    };

    const tagOptions = tagList.map((tag) => ({
        label: tag,
        value: tag,
    }));

    const handleDescriptionSwitch = (mode) => {
        setActiveMode(mode);
        SetFormateData((prev) => ({
            ...prev,
            description: ""
        }))
    };

    return (
        <div>
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            )}
            <ValidatorForm id="cpm_details" className="customForm" onSubmit={(e) => onSubmit(e)}>
                <div className="row">
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                        <div className="form-group">
                            <label>Business Goal</label>
                            <SelectValidator placeholder="Select Business Goal" className="custom-ReactSelect bordered no____value" name="businessGoal" value={selectValueGetter(options, businessGoal)} selected={businessGoal} options={options} onChange={(e) => onChange({ target: { name: "businessGoal", value: e.value } })} />
                            <span className="errorMessage">{error && error.errBusiness && error.errBusinessMsg}</span>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                        <div className="form-group">
                            <label>Campaign Name</label>
                            <TextValidator placeholder="Campaign Name" type="text" className="form-control no____value" value={name} name="name" onChange={onChange} />
                            <span className="errorMessage">{error && error.errName && error.errNameMsg}</span>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                        <div className="form-group">
                            <label>Start Date</label>

                            <TextValidator type="date" className="form-control no____value" min={getDate(new Date(), "YYYY-MM-DD")} value={getDate(startDateTime, "YYYY-MM-DD")} name="startDateTime" onChange={onChange} />
                            <span className="errorMessage">{error && error.errStartDate && error.errStartDateMsg}</span>
                            <span className="errorMessage">{error && error.errDateDiff && error.errDateDiffMsg}</span>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                        <div className="form-group">
                            <label>End Date</label>
                            <TextValidator type="date" className="form-control no____value" min={getDate(startDateTime, "YYYY-MM-DD")} value={getDate(endDateTime, "YYYY-MM-DD")} name="endDateTime" onChange={onChange} />
                            <span className="errorMessage">{error && error.errEndDate && error.errEndDateMsg}</span>
                        </div>
                    </div>

                    <div className="col-sm-12 col-md-12 col-lg-12">
                        <div className="form-group">
                            <label>Description</label>

                            <div className="mb-3 d-flex">
                                <button
                                    type="button"
                                    name="description"
                                    onClick={() => handleDescriptionSwitch("editor")}
                                    className={`btn ${activeMode === "editor"
                                        ? "btn-primary"
                                        : "btn-outline-secondary"
                                        } me-2`}
                                >
                                    Editor
                                </button>

                                <button
                                    type="button"
                                    name="description"
                                    onClick={() => handleDescriptionSwitch("custom")}
                                    className={`btn ${activeMode === "custom"
                                        ? "btn-primary"
                                        : "btn-outline-secondary"
                                        }`}
                                >
                                    Custom
                                </button>
                            </div>

                            {activeMode === "custom" ? (
                                <textarea
                                    name="description"
                                    value={description}
                                    onChange={onChange}
                                    rows={10}
                                    className="form-control"
                                />
                            ) : (
                                <CKEditor
                                    config={{ versionCheck: false }}
                                    data={description}
                                    onChange={onChange}
                                />
                            )}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <div className="form-group withSwitch">
                                <label>
                                    Status:
                                    <Switch name="status" checked={status} onChange={(e) => onChange({ target: { name: 'status', value: e } })} onColor={status ? "#50BC14" : "#E50000"} onHandleColor="#50BC14" handleDiameter={30} uncheckedIcon={true} checkedIcon={false} boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)" activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)" height={20} width={48} className="react-switch" />
                                </label>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-group">

                                {/* <label>
                                    Promotion:
                                    <Switch
                                        name="tags"
                                        checked={tags && tags.length > 0}
                                        onChange={(e) => onChange({ target: { name: "tags", value: e } })}
                                        onColor={tags && tags.length > 0 ? "#50BC14" : "#E50000"}
                                        onHandleColor="#50BC14"
                                        handleDiameter={30}
                                        uncheckedIcon={true}
                                        checkedIcon={false}
                                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                        height={20}
                                        width={48}
                                        className="react-switch"
                                    />
                                </label> */}
                                <label>Promotion</label>
                                <SelectValidator placeholder="Select"
                                    className="custom-ReactSelect bordered no____value"
                                    value={selectValueGetter(templateOptions, taglastcheck)}
                                    selected={taglastcheck} options={templateOptions}
                                    onChange={(e) => onChange({ target: { name: "taglastcheck", value: e?.value } })} />
                            </div>
                        </div>
                        <div className="col-md-4">

                            <div className="form-group">

                                {/* <label>
                                    Promotion:
                                    <Switch
                                        name="tags"
                                        checked={tags && tags.length > 0}
                                        onChange={(e) => onChange({ target: { name: "tags", value: e } })}
                                        onColor={tags && tags.length > 0 ? "#50BC14" : "#E50000"}
                                        onHandleColor="#50BC14"
                                        handleDiameter={30}
                                        uncheckedIcon={true}
                                        checkedIcon={false}
                                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                        height={20}
                                        width={48}
                                        className="react-switch"
                                    />
                                </label> */}
                                <label>Processing Mode</label>
                                <SelectValidator placeholder="Select"
                                    className="custom-ReactSelect bordered no____value"
                                    value={selectValueGetterr(Options, processingMode)}
                                    selected={processingMode} options={Options}
                                    onChange={(e) => onChange({ target: { name: "processingMode", value: e } })} />

                            </div>

                        </div>
                        <div className="col-md-4">
                            <div className="form-group">
                                <label>
                                    Upload Image
                                </label>

                                <input
                                    className="form-control"
                                    type="file"
                                    ref={imageInputRef}
                                    accept="image/png, image/gif, image/jpeg, image/jpg"
                                    onChange={handleFile}
                                />

                                {imgSize && (
                                    <span style={{ color: "red" }}>
                                        Image size not more than 1 MB
                                    </span>
                                )}
                            </div>
                        </div>

                        {formateData?.offerDetail?.imageLink && (
                            <div className="col-md-2">
                                <div style={{ position: "relative", width: "100px" }}>
                                    <img
                                        src={formateData.offerDetail.imageLink}
                                        alt="uploaded preview"
                                        style={{
                                            width: "100px",
                                            height: "70px",
                                            objectFit: "cover",
                                            borderRadius: "6px",
                                            border: "1px solid #ddd",
                                        }}
                                    />

                                    <button
                                        type="button"
                                        onClick={() => {
                                            handleImgUpload(null);

                                            if (imageInputRef.current) {
                                                imageInputRef.current.value = "";
                                            }
                                        }}
                                        style={{
                                            position: "absolute",
                                            top: "-6px",
                                            right: "-6px",
                                            width: "18px",
                                            height: "18px",
                                            borderRadius: "50%",
                                            border: "none",
                                            cursor: "pointer",
                                            fontSize: "12px",
                                            lineHeight: "18px",
                                            padding: 0,
                                        }}
                                    >
                                        ×
                                    </button>
                                </div>
                            </div>
                        )}
                        <div className="col-md-4">
                            <div className="form-group">
                                <label>Add Tags</label>

                                <div className="d-flex gap-2 mb-3">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter tag name"
                                        value={newTag}
                                        onChange={(e) => setNewTag(e.target.value)}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                e.preventDefault();
                                                handleAddTag();
                                            }
                                        }}
                                    />

                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={handleAddTag}
                                    >
                                        Add
                                    </button>
                                </div>

                            </div>
                        </div>
                        <div className="col-md-4">
                            {tagList.length > 0 && (
                                <div className="form-group">
                                    <label>Tag List</label>

                                    <div
                                        className=" d-flex flex-nowrap gap-2 overflow-auto align-items-center border rounded bg-light p-2"
                                    >
                                        {tagList.map((tag) => (
                                            <div
                                                key={tag}
                                                className=" badge bg-secondary d-flex align-items-center flex-shrink-0 px-3 py-2"
                                            >
                                                <span>{tag}</span>

                                                <button
                                                    type="button"
                                                    className="btn-close btn-close-white ms-2"
                                                    aria-label="Remove"
                                                    onClick={() => {
                                                        const updatedTagList = tagList.filter(
                                                            (item) => item !== tag
                                                        );

                                                        setTagList(updatedTagList);

                                                        const updatedTags = updatedTagList.map(
                                                            (item) => ({
                                                                TagKey: item,
                                                                Values: [
                                                                    {
                                                                        Name: item,
                                                                        Color: "#d81313",
                                                                    },
                                                                ],
                                                            })
                                                        );

                                                        onChange({
                                                            target: {
                                                                name: "tags",
                                                                value: updatedTags,
                                                            },
                                                        });
                                                    }}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>

                    </div>
                    <div className="col-sm-4 col-md-4 col-lg-4">
                        <div className="form-group"></div>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12">
                        <div className="button-section">
                            <button type="button" className="btn btn-primary" onClick={handleNext}>
                                Next
                            </button>
                            {/* <button type="button" className="btn btn-outline-primary">
							Save as draft
						</button>
						<button type="button" className="btn btn-primary">
							Publish Offer
						</button> */}
                        </div>
                    </div>
                </div >
            </ValidatorForm >
        </div >
    );
};

const mapStateToProps = (state) => ({
    BusinessGoal: state.BusinessGoal.data,

});
const mapDispatchToProps = {
    getBusinessGoal,
    clearBusinessGoal,

};

export default connect(mapStateToProps, mapDispatchToProps)(CampaignDetailsTab);
 